<div class="main-container">
    <div class="top-container">
        <p>Import from existing booking</p>
        <p-dropdown placeholder="Select" [options]="bookings" [filter]="true" filterBy="label" (onChange)="importBooking($event.value)"
            optionLabel="label"></p-dropdown>
    </div>

    <div [formGroup]="bookingForm" class="booking-form-container">
        <div>
            <p>First name</p>
            <input pInputText formControlName="studentFirstName">
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['studentFirstName'].invalid">First name
                is missing</p>
        </div>
        <div>
            <p>Last name</p>
            <input pInputText formControlName="studentLastName">
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['studentLastName'].invalid">Last name
                is missing</p>
        </div>
        <div>
            <p>Destination</p>
            <p-dropdown placeholder="Destination" [options]="countries" optionLabel="name" formControlName="destination"
                (onChange)="onDestinationChange($event.value)" [filter]="true" filterBy="name"></p-dropdown>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['destination'].invalid">Destination is
                missing</p>
        </div>
        <div>
            <p>School</p>
            <p-dropdown placeholder="School" [options]="schools" optionLabel="name" formControlName="school"
                (onChange)="onSchoolChange()">
            </p-dropdown>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['school'].invalid">School is missing
            </p>
        </div>
        <div *ngIf="bookingForm.value.school">
            <p>Course</p>
            <p-dropdown placeholder="Course" [options]="languageCourses" optionLabel="code"
                formControlName="languageCourse">
            </p-dropdown>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['languageCourse'].invalid">Course is
                missing</p>
        </div>
        <div>
            <p>Accommodation</p>
            <p-dropdown placeholder="Accommodation" [options]="accommodationTypes" optionLabel="name"
                formControlName="accommodationType"></p-dropdown>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['accommodationType'].invalid">
                Accommodation is missing</p>
        </div>
        <div>
            <p>Room</p>
            <p-dropdown placeholder="Room" [options]="roomTypes" optionLabel="name" formControlName="roomType">
            </p-dropdown>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['roomType'].invalid">Room is missing
            </p>
        </div>
        <div>
            <p>Board</p>
            <p-dropdown placeholder="Board" [options]="boardTypes" optionLabel="name" formControlName="boardType">
            </p-dropdown>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['boardType'].invalid">Board is missing
            </p>
        </div>
        <div>
            <p>Language Level of student</p>
            <p-dropdown placeholder="Language Level" [options]="languageLevels" optionLabel="name"
                formControlName="targetLanguageLevel"></p-dropdown>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['targetLanguageLevel'].invalid">
                Language level is missing</p>

        </div>
        <div>
            <p>Agent</p>
            <p-dropdown placeholder="Agent" [options]="salesAgents" optionLabel="name" formControlName="salesAgent">
            </p-dropdown>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['salesAgent'].invalid">Agent is missing
            </p>
        </div>
        <div>
            <p>Language</p>
            <p-dropdown placeholder="Language" [options]="languages" optionLabel="name"
                formControlName="studentLanguage">
            </p-dropdown>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['studentLanguage'].invalid">Language is
                missing</p>
        </div>
        <div>
            <p>
                Start date
            </p>
            <p-calendar [monthNavigator]="true" [yearRange]="bookingYearRange" [yearNavigator]="true"
                formControlName="startDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['startDate'].invalid">Start date is
                missing</p>
        </div>
        <div>
            <p>End date</p>
            <p-calendar [monthNavigator]="true" [yearRange]="bookingYearRange" [yearNavigator]="true"
                formControlName="endDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
            <p class="global-warning" *ngIf="formInvalid && bookingForm.controls['endDate'].invalid">End date is missing
            </p>
        </div>
        <div>
            <p>Birth date</p>
            <p-calendar [monthNavigator]="true" [yearRange]="birthYearRange" [yearNavigator]="true"
                formControlName="studentBirthDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
        </div>
        <div>
            <p>Gender</p>
            <p-dropdown placeholder="Gender" [options]="genders" formControlName="studentGender" optionLabel="name">
            </p-dropdown>
        </div>
        <div>
            <p>Allergies</p>
            <input pInputText formControlName="studentAllergies">
        </div>
    </div>

    <div>
        <p-button label="Submit" (onClick)="submitBooking()"></p-button>
    </div>
</div>